export default __webpack_public_path__ + "static/media/add-district-gold.181bb937.svg";